import PropTypes from "prop-types";

import { CircularProgress } from "@mui/material";
import { Backdrop } from "@wealthx/ui";

/**
 * * instead of wrapping the container, fullscreen mode will cover the whole page
 */
const LoadingBackdrop = ({
  isOpen = true,
  handleClose = () => {},
  content = "Loading Data...",
  fullscreen = false,
  backgroundColor = undefined,
}) => {
  return (
    <Backdrop
      className={`loading-modal ${fullscreen ? "fullscreen" : ""}`}
      open={isOpen}
      onClick={handleClose}
      style={{ backgroundColor }}
    >
      <div className="loading-modal__text-container">
        <CircularProgress color="inherit" />
        <div className="loading-modal__text">{content}</div>
      </div>
    </Backdrop>
  );
};

LoadingBackdrop.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
};

export default LoadingBackdrop;
export { LoadingBackdrop };
